import { Platform, StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const globalErrorModalStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: Platform.OS === 'ios' ? theme.background : theme.lightBackground,
      zIndex: Platform.OS === 'web' ? 9999 : 0
    },
    modal: {
      backgroundColor: theme.modalBG,
      paddingHorizontal: Typography.padding.padding24,
      borderRadius: Typography.radius.radius8,
      minWidth: Typography.width.width512,
    },
    header: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      alignItems: Typography.textAlign.centerAlign,
      paddingVertical: Typography.padding.padding20,
      maxWidth: Typography.width.width549,
    },
    headerTitle: {
      fontSize: Typography.fontSize.fontSize24,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.rethinkSans,
      color: theme.headerText,
      lineHeight: Typography.lineHeight.lineHeight36,
    },
    titleSubContainer: {
      gap: Typography.gap.gap10,
    },
    titleContainer: {
      paddingVertical: Typography.padding.padding16,
      maxWidth: Typography.width.width549,
    },
    headerTitleContainer: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap6,
    },
    iconContainer: {
      width: Typography.icon.icon24,
      height: Typography.icon.icon24,
      flexShrink: 0,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },
    title: {
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize16,
      fontWeight: Typography.fontWeight.regular,
      color: theme.headerText,
      marginBottom: Typography.margin.margin12,
    },
    message: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
      color: theme.headerText,
    },
    buttonContainer: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.flexEnd,
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap16,
      paddingVertical: Typography.padding.padding20,
    },
    buttonContainerTextStyles: {
      gap: Typography.gap.gap8,
      alignItems: Typography.textAlign.centerAlign,
    },
    cancelContainerStyle: {
      // backgroundColor: 'transparent',
      // borderColor: theme.cancelBtnBorder,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    cancelCustomTextStyle: {
      //color: theme.cancelBtnText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
    },
  });